// Mapeo de países a continentes (195 países)
export const countryContinents = {
    // ========== AMÉRICA (35 países) ==========

    // América del Norte
    'US': 'America', 'CA': 'America', 'MX': 'America',

    // América Central
    'GT': 'America', 'BZ': 'America', 'SV': 'America', 'HN': 'America',
    'NI': 'America', 'CR': 'America', 'PA': 'America',

    // Caribe
    'CU': 'America', 'JM': 'America', 'HT': 'America', 'DO': 'America',
    'PR': 'America', 'TT': 'America', 'BS': 'America', 'BB': 'America',
    'LC': 'America', 'GD': 'America', 'VC': 'America', 'AG': 'America',
    'DM': 'America', 'KN': 'America',

    // América del Sur
    'CO': 'America', 'VE': 'America', 'GY': 'America', 'SR': 'America',
    'GF': 'America', 'BR': 'America', 'EC': 'America', 'PE': 'America',
    'BO': 'America', 'CL': 'America', 'AR': 'America', 'UY': 'America',
    'PY': 'America',

    // ========== EUROPA (50 países) ==========

    // Europa Occidental
    'GB': 'Europe', 'IE': 'Europe', 'FR': 'Europe', 'ES': 'Europe',
    'PT': 'Europe', 'AD': 'Europe', 'MC': 'Europe', 'BE': 'Europe',
    'NL': 'Europe', 'LU': 'Europe', 'DE': 'Europe', 'CH': 'Europe',
    'AT': 'Europe', 'LI': 'Europe', 'IT': 'Europe', 'SM': 'Europe',
    'VA': 'Europe', 'MT': 'Europe',

    // Europa del Norte
    'IS': 'Europe', 'NO': 'Europe', 'SE': 'Europe', 'FI': 'Europe',
    'DK': 'Europe', 'EE': 'Europe', 'LV': 'Europe', 'LT': 'Europe',

    // Europa Central
    'PL': 'Europe', 'CZ': 'Europe', 'SK': 'Europe', 'HU': 'Europe',
    'SI': 'Europe', 'HR': 'Europe', 'BA': 'Europe', 'RS': 'Europe',
    'ME': 'Europe', 'XK': 'Europe', 'MK': 'Europe', 'AL': 'Europe',

    // Europa del Este
    'RU': 'Europe', 'UA': 'Europe', 'BY': 'Europe', 'MD': 'Europe',
    'RO': 'Europe', 'BG': 'Europe', 'GR': 'Europe', 'TR': 'Europe',
    'CY': 'Europe',

    // ========== ASIA (48 países) ==========

    // Asia Oriental
    'CN': 'Asia', 'JP': 'Asia', 'KR': 'Asia', 'KP': 'Asia',
    'MN': 'Asia', 'TW': 'Asia', 'HK': 'Asia', 'MO': 'Asia',

    // Sudeste Asiático
    'TH': 'Asia', 'VN': 'Asia', 'LA': 'Asia', 'KH': 'Asia',
    'MM': 'Asia', 'MY': 'Asia', 'SG': 'Asia', 'ID': 'Asia',
    'BN': 'Asia', 'PH': 'Asia', 'TL': 'Asia',

    // Asia del Sur
    'IN': 'Asia', 'PK': 'Asia', 'BD': 'Asia', 'LK': 'Asia',
    'NP': 'Asia', 'BT': 'Asia', 'MV': 'Asia', 'AF': 'Asia',

    // Medio Oriente
    'SY': 'Asia', 'LB': 'Asia', 'IL': 'Asia', 'PS': 'Asia',
    'JO': 'Asia', 'IQ': 'Asia', 'SA': 'Asia', 'YE': 'Asia',
    'OM': 'Asia', 'AE': 'Asia', 'QA': 'Asia', 'BH': 'Asia',
    'KW': 'Asia', 'IR': 'Asia', 'GE': 'Asia', 'AM': 'Asia',
    'AZ': 'Asia',

    // Asia Central
    'KZ': 'Asia', 'UZ': 'Asia', 'TM': 'Asia', 'KG': 'Asia',
    'TJ': 'Asia',

    // ========== ÁFRICA (54 países) ==========

    // África del Norte
    'MA': 'Africa', 'DZ': 'Africa', 'TN': 'Africa', 'LY': 'Africa',
    'EG': 'Africa', 'SD': 'Africa', 'SS': 'Africa',

    // África Occidental
    'MR': 'Africa', 'ML': 'Africa', 'NE': 'Africa', 'TD': 'Africa',
    'SN': 'Africa', 'GM': 'Africa', 'GW': 'Africa', 'GN': 'Africa',
    'SL': 'Africa', 'LR': 'Africa', 'CI': 'Africa', 'BF': 'Africa',
    'GH': 'Africa', 'TG': 'Africa', 'BJ': 'Africa', 'NG': 'Africa',
    'CM': 'Africa',

    // África Central
    'CF': 'Africa', 'GQ': 'Africa', 'GA': 'Africa', 'CG': 'Africa',
    'CD': 'Africa', 'AO': 'Africa',

    // África Oriental
    'ER': 'Africa', 'ET': 'Africa', 'DJ': 'Africa', 'SO': 'Africa',
    'KE': 'Africa', 'UG': 'Africa', 'RW': 'Africa', 'BI': 'Africa',
    'TZ': 'Africa', 'MZ': 'Africa', 'MW': 'Africa', 'ZM': 'Africa',
    'ZW': 'Africa', 'MG': 'Africa', 'MU': 'Africa', 'SC': 'Africa',
    'KM': 'Africa',

    // África del Sur
    'NA': 'Africa', 'BW': 'Africa', 'ZA': 'Africa', 'SZ': 'Africa',
    'LS': 'Africa',

    // ========== OCEANÍA (14 países) ==========
    'AU': 'Oceania', 'NZ': 'Oceania', 'PG': 'Oceania', 'FJ': 'Oceania',
    'SB': 'Oceania', 'VU': 'Oceania', 'NC': 'Oceania', 'WS': 'Oceania',
    'TO': 'Oceania', 'KI': 'Oceania', 'FM': 'Oceania', 'MH': 'Oceania',
    'PW': 'Oceania', 'NR': 'Oceania', 'TV': 'Oceania', 'CK': 'Oceania',
    'PF': 'Oceania', 'GU': 'Oceania'
};

export const getContinent = (countryCode) => {
    return countryContinents[countryCode] || 'World';
};